import {callApi} from '../middleware/api'

export const fetchInitialLive = (requestData) => callApi(`/api/live/current?languageId=${requestData.languageId}`, 'get');
export const fetchLiveUpdate = (requestData) => callApi(`/api/live/update?version=${requestData.version}&languageId=${requestData.languageId}`, 'get');

export const fetchInitialTimetable = (requestData) => callApi(`/api/timetable/current?languageId=${getLanguageId(requestData.languageId)}`, 'get');
export const fetchTimetableUpdate = (requestData) => callApi(`/api/timetable/update?version=${requestData.version}&languageId=${getLanguageId(requestData.languageId)}`, 'get');

export const fetchUserBalance = (requestData) => callApi('/api/balance/', 'post', requestData, true);
export const fetchFreebet = () => callApi('/api/gambler/freebet', 'get', {}, true);

export const fetchBetStatus = (requestData) => callApi(`/api/bet/${requestData.betId}/status?stakeId=${requestData.stakeId}&languageId=${getLanguageId(requestData.languageId)}`, 'get', {}, true);
export const fetchStakeStatus = (requestData) => callApi(`/api/bet/${requestData.betId}/stake/${requestData.stakeId}/status`, 'get', {}, true);
export const fetchCashoutStatus = (requestData) => callApi(`/api/bet/${requestData.betId}/stake/cashout/${requestData.requestId}/status`, 'get', {}, true);


function getLanguageId(languageId) {
  if(languageId === 13) return 5
  return languageId
}


// WEBPACK FOOTER //
// ./js/sagas/api.js